import React, { Component } from 'react';
import { Link } from 'react-router-dom'

import {findDOMNode} from 'react-dom';

import Inner from './Inner'; 

export default class Menu extends Component {

  openMenu = () => {
    findDOMNode(this.refs.nav).classList.add('navOpen');
    findDOMNode(this.refs.navOverlay).classList.add('navOpen');
  };

  closeMenu = () => {
    findDOMNode(this.refs.nav).classList.remove('navOpen');
    findDOMNode(this.refs.navOverlay).classList.remove('navOpen');
  };

  render() {
    return (
      <div>
        <div className="menu">
          <Inner>
            <Link to="/">
              <span className="menuLogo" aria-label="Kammeradvokaten Advokatfirmaet Poul Schmith"></span>
            </Link>
            <button type="button" className="menuButton" onClick={this.openMenu} aria-label='Åben menuen'><span>Menu</span></button>
          </Inner>
        </div>
        <button type="button" className="navOverlay" onClick={this.closeMenu} aria-label='Luk menuen' ref="navOverlay" />
        
        <nav className="nav" ref="nav">
          <button type="button" className="navContainerButton" onClick={this.closeMenu} aria-label="Luk menuen" />
          <div className="navContainer">
            <div className="navHeader"></div>
            <div className="navMain">
              <div className="navPrimary">
                <h4 className="navLabel">Menu</h4>
                <ul className="navList">
                  <li><Link onClick={this.closeMenu} to="/">Beregning af frister</Link></li>
                </ul>
              </div>
              <div className="navSecondary">
                <ul className="navListSecond">
                  <li><Link onClick={this.closeMenu} to="/about">Om Fristberegneren</Link></li>
                  <li><Link onClick={this.closeMenu} to="/terms">Vilkår og betingelser</Link></li>
                  <li><Link onClick={this.closeMenu} to="https://kammeradvokaten.dk/personer/niels-karl-heilskov-rytter/" target="_blank">Kontakt</Link></li>
                </ul>
              </div>
            </div>
            <footer className="navFooter">
              <p>Idé og udvikling af
                <span className="navFooterLogo" aria-label="Kammeradvokaten Advokatfirmaet Poul Schmith"></span>
              </p>
            </footer>
          </div>
        </nav>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Menu.js